import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import * as serviceWorker from './serviceWorker';

import './index.css';
import App from './App';
import burgerBuilderReducer from './store/reducers/burgerBuilderReducer';
import orderReducer from './store/reducers/orderReducer';
import authReducer from './store/reducers/authReducer';


// const devEnvironment = process.env.NODE_ENV === "development" ? true : false

// set to True for development environment
const devEnvironment = false;

// composeEnhancers allows to use redux devtools extension
const composeEnhancers = devEnvironment ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

// combine reducers
const rootReducer = combineReducers({
    bg: burgerBuilderReducer,
    order: orderReducer,
    auth: authReducer
});

// Note that we added thunk middleware to be able to dispatch 
// some of the actions async, otherwise all actions are dispatched sync
const store = createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(thunk)
    )
);

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);
ReactDOM.render(app, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
